/** Tenant activity feed backed by immutable audit logs. */

import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../lib/api-client'

export interface ActivityEvent {
  id: string
  action: string
  label: string
  resourceType: string | null
  resourceId: string | null
  actorName: string | null
  actorEmail: string | null
  createdAt: number
}

export function useActivity(limit = 8) {
  return useQuery<{ events: ActivityEvent[] }>({
    queryKey: ['activity', limit],
    queryFn: () => apiClient.get<{ events: ActivityEvent[] }>(`/api/activity?limit=${limit}`),
    staleTime: 1000 * 30,
    retry: false,
  })
}
